/**
 * @author    yewon@zumper.com (Yewon Lee)
 * @copyright Copyright (c) 2016, Padmapper
 */

type Callback<Obj extends object, Output> = (
  ...params: Exclude<
    { [Key in keyof Obj]: [value: Obj[Key], key: Key, obj: Obj] }[keyof Obj],
    undefined // not sure how undefined got in there in the first place
  >
) => Output

/**
 * map over Object.keys, callback(value, key, obj)
 *
 * @param obj
 * @param callback
 * @returns Array of values from callback
 */
export const omap = <Obj extends object, Output>(
  obj: Obj | null | undefined,
  callback: Callback<Obj, Output>
): Output[] => {
  if (obj) {
    // @ts-expect-error `string` isn't assignable to `keyof Obj`
    return Object.keys(obj).map((k) => callback(obj[k], k, obj))
  }
  return []
}

/**
 * FILTERED map over Object.keys (do not accumulate undefined), callback(value, key, obj)
 *
 */
export const omapFiltered = <Obj extends object, Output>(
  obj: Obj | null | undefined,
  callback: Callback<Obj, Output | undefined>
): Output[] => {
  const output = []
  if (obj) {
    for (const k of Object.keys(obj)) {
      // @ts-expect-error `string` isn't assignable to `keyof Obj`
      const v = callback(obj[k], k, obj)
      if (v !== undefined) {
        output.push(v)
      }
    }
  }
  return output
}
